export default __webpack_public_path__ + "static/media/Ramps_small.256.e17131ad.png";